// renovacionesColumns.js
import React from "react";
import FilterSelect from "../../../components/Generales/FilterSelect";


export const renovacionesColumns = (componentInstance) => [
  {
    field: "contador",
    header: "#",
    sortable: false,
    filter: false,
    style: { width: "60px" }
  },
  {
    field: "noItems",
    header: "# Ítems",
    sortable: false,
    filter: false,
    style: { width: "60px" }
  },
  {
    field: "fechaCreacion",
    header: "Inicio de vigencia",
    sortable: false,
    filter: false,
    style: { width: "150px" }
  },
  {
    field: "mesCaducidad",
    header: "Fin de vigencia",
    sortable: true,
    filter: false,
    style: { width: "150px" }
  },
  {
    field: "polDescripcionRamo",
    header: "Ramo",
    sortable: false,
    filter: true,
    filterMatchMode: "equals",
    filterElement: (options) => (
      <FilterSelect
        value={options.value}
        onChange={(val) => options.filterCallback(val)}
        options={componentInstance.state.ramosDisponibles}
      />
    ),
    style: { width: "150px" }
  },
  {
    field: "nombreContratante",
    header: "Contratante",
    sortable: false,
    filter: true,
    filterPlaceholder: "Buscar contratante...",
    style: { width: "150px" }
  },
  {
    field: "polIdentificacionesAsegurados",
    header: "Nro. de identificación",
    sortable: false,
    filter: true,
    filterPlaceholder: "Buscar nro. de identificación...",
    style: { width: "150px" }
  },
  {
    field: "emailContratante",
    header: "Email",
    sortable: false,
    filter: true,
    filterPlaceholder: "Buscar email del contratante...",
    style: { width: "150px" }
  },
  {
    field: "placa",
    header: "Placa",
    sortable: false,
    filter: true,
    filterPlaceholder: "Buscar placa...",
    body: (rowData) => rowData.polDescripcionRamo === 'PYMES' ? "" : rowData.placa,
    style: { width: "150px" }
  },
  {
    field: "marca",
    header: "Marca",
    sortable: false,
    filter: true,
    filterPlaceholder: "Buscar marca...",
    body: (rowData) => rowData.polDescripcionRamo === 'PYMES' ? "" : rowData.marca,
    style: { width: "150px" }
  },
  {
    field: "modelo",
    header: "Modelo",
    sortable: false,
    filter: true,
    filterPlaceholder: "Buscar modelo...",
    body: (rowData) => rowData.polDescripcionRamo === 'PYMES' ? "" : rowData.modelo,
    style: { width: "150px" }
  },
  {
    field: "polDescripcionSeguroVer",
    header: "Producto",
    sortable: false,
    filter: true,
    filterPlaceholder: "Buscar producto...",
    style: { width: "150px" }
  },
  {
    field: "numeroPolizaEmision",
    header: "Número Póliza",
    sortable: false,
    filter: true,
    filterPlaceholder: "Buscar póliza...",
    style: { width: "150px" }
  },
  {
    field: "sumaAsegurada",
    header: "Suma asegurada anterior",
    sortable: false,
    filter: false,
    body: (rowData) => rowData.polDescripcionRamo === 'PYMES' ? "" : rowData.sumaAsegurada,
    style: { width: "150px" }
  },
  {
    field: "estadoVer",
    header: "Estado",
    sortable: false,
    filter: true,
    filterMatchMode: "equals",
    filterElement: (options) => (
      <FilterSelect
        value={options.value}
        onChange={(val) => options.filterCallback(val)}
        options={componentInstance.state.estadosDisponibles}
      />
    ),
    style: { width: "150px" },
    body: (rowData) => componentInstance.bodyVerEstados(rowData)
  },
  {
    header: "Detalles",
    body: (rowData) => componentInstance.bodyVerDetalles(rowData),
    sortable: false,
    filter: false,
    style: { width: "265px" }
  }
];
